<template>
<!-- 会员管理 详情页 -->
<div class="main_container">
  <div style="padding: 15px 20px 50px 20px;">
    <div class="cooperative_brand">
      <div class="info">会员卡信息</div>
    </div>
    <el-form style="margin-top:25px" label-width="50px">
      <el-form-item style="display:flex;width:60%" label="会员卡名称：">
        <el-input :disabled="seeDis" v-model="cardName" style="width:390px" placeholder="请输入会员卡名称" maxlength="10"/>
      </el-form-item>
      <el-form-item style="display:flex;width:60%" label="会员卡价格：">
        <el-input :disabled="seeDis" v-model="price"
          onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
          style="width:390px" placeholder="请输入会员卡价格" maxlength="10"/>
      </el-form-item>
      <el-form-item style="display:flex;width:60%" label="会员卡有效期：">
        <el-select :disabled="seeDis" v-model="useTimeId" style="width:390px" placeholder="请选择">
          <el-option v-for="item in stautIdarr" :key="item.Id" :label="item.Name" :value="item.Id"/>
        </el-select>
      </el-form-item>
      <el-form-item style="display:flex;width:60%" label="开放城市：">
        <el-cascader :disabled="seeDis" v-model="openCity" style="width:390px" placeholder="请选择"
          filterable clearable :options="options" :props="props" @change="handleChange"/>
        </el-form-item>
    </el-form>
    <div class="cooperative_brand">
      <div class="info">会员卡合作品牌</div>
      <div class="operation_button">
        <el-button type="danger" v-show="showSeeDis" @click="addNewBrand()">新增</el-button>
        <el-button type="danger" v-show="showSeeDis" @click="deleteBrand()">删除</el-button>
      </div>
    </div>
    <!-- 合作品牌查询列表 -->
    <el-table :data="tableUsers" :span-method="objectSpanMethod" stripe border
      @selection-change="handleSelectionChange" style="height:auto;margin:20px 0;">
      <el-table-column type="selection" align="center"/>
      <el-table-column prop="BrandName" label="品牌" align="center">
        <template scope="scope">
          <span :title="scope.row.BrandName">{{scope.row.BrandName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="BbName" label="合作店铺" align="center">
        <template scope="scope">
          <span :title="scope.row.BbName">{{scope.row.BbName}}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="佣金比例" align="center">
        <el-table-column prop="DiscountRate" label="普通商品" align="center">
          <template scope="scope">
            <span>{{scope.row.DiscountRate}}%</span>
          </template>
        </el-table-column>
        
        <el-table-column prop="BlastDiscountRate" label="特价商品" align="center">
          <template scope="scope">
            <span>{{scope.row.BlastDiscountRate}}%</span>
          </template>
        </el-table-column>
      </el-table-column> -->
      <!-- <el-table-column label="客户返现比例" align="center">
        <el-table-column prop="ReturnRate" label="普通商品" align="center">
          <template scope="scope">
            <span>{{scope.row.ReturnRate}}%</span>
          </template>
        </el-table-column>
        
        <el-table-column prop="BlastReturnRate" label="特价商品" align="center">
          <template scope="scope">
            <span>{{scope.row.BlastReturnRate}}%</span>
          </template>
        </el-table-column>
      </el-table-column> -->
      <!-- <el-table-column label="一级共创抽佣比例" align="center">
        <el-table-column prop="FirstCoRate" label="普通商品" align="center">
          <template scope="scope">
            <span>{{scope.row.FirstCoRate}}%</span>
          </template>
        </el-table-column>
        
        <el-table-column prop="BlastFirstCoRate" label="特价商品" align="center">
          <template scope="scope">
            <span>{{scope.row.BlastFirstCoRate}}%</span>
          </template>
        </el-table-column>
      </el-table-column> -->
      <!-- <el-table-column label="二级共创抽佣比例" align="center">
        <el-table-column prop="SecondRate" label="普通商品" align="center">
          <template scope="scope">
            <span>{{scope.row.SecondRate}}%</span>
          </template>
        </el-table-column>
        
        <el-table-column prop="BlastSecondRate" label="特价商品" align="center">
          <template scope="scope">
            <span>{{scope.row.BlastSecondRate}}%</span>
          </template>
        </el-table-column>
      </el-table-column> -->
      <el-table-column prop label="操作" width="270px" fixed="right" align="center" v-if="showSeeDis">
        <template scope="scope">
          <span class="handle" @click="offer(scope.row)"> <i class="el-icon-edit-outline"></i> 编辑 </span>
          <span class="handle" @click="deleteone(scope.row)"> <i class="el-icon-delete"></i> 删除 </span>
        </template>
      </el-table-column>
    </el-table>
    <div class="gudingdibu">
      <el-button @click="goback()">取消</el-button>
      <el-button type="danger" @click="endPreservation()" v-show="showSeeDis">保存</el-button>
    </div>
  </div>
  <!-- 新增合作品牌 -->
  <addCooperativeBrand v-if="brandVisible" :cityIds='openCity' :cardId="cardId" ref="addBrand" @refreshDataList="refreshSelectBrand($event,dataList)"/>
</div>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { getkind, getProvinceAndCityAndZoneByDataType, getSelectVIPCardById,
getSelectCCPByCity, getUpdateVIPCard, deleteCooperatePartner } from "../../api/api";
import addCooperativeBrand from './addCooperativeBrand';
export default {
  name: "MemberDetails",
  mixins: [alertTrends],
  data() {
    return {
      dataList:[],
      type: 1, // 1 编辑 2 查看
      cardId: "", // 会员卡id
      seeDis: false, // 查看进来时：按钮置灰
      showSeeDis: true, // 查看进来时：控制 新增、删除、保存按钮
      brandVisible: false, // 合作品牌弹框
      addCooperativeBrand: false, // 新增参展品牌
      cardName:"", // 会员卡名称。最多10字符
      price:"", // 会员卡售价，取值范围：￥0.01 - 9999999.99
      useTimeId: 0, // 会员卡有效期
      stautIdarr: [], // 会员卡有效期-数组
      tableUsers: [],
      brandIdArr: [], // 批量删除
      provinceId: 0, // 省
      cityId: 0, // 市
      props: { multiple: true }, // 开放城市 支持多选
      optionsindex: "",
      options: [],
      openCity:[], // 选择的选项格式: [[1,3],[1,4]] 1是省id, 3 4 是市id
      provinceIds: [] // 被选择的多个省
    };
  },
  components: {
    addCooperativeBrand // 新增合作品牌
  },
  methods: {
    init() {
      this.type = this.$route.query.type || 1
      this.cardId = this.$route.query.id || ""
      // 编辑、查看 带会员卡id进来
      if (this.cardId) {
        var obj = {
          userId: localStorage.Id,
          id: this.cardId
        }
        getSelectVIPCardById(obj).then(data=>{
          if(data.ResultCode == 1){
            this.cardName = data.ResultObj.Name
            this.price = data.ResultObj.Price
            this.useTimeId = data.ResultObj.UseTimeId
            this.tableUsers = data.ResultObj.GoldVipCPBrands // 合作品牌列
            for(let item of data.ResultObj.GoldVipOpenCityModels){
              this.openCity.push([item.ProvinceId,item.CityId]) // 把 [1,1], 加入了数组， 一共加入了三次
            }
          }
        })
      }
      // 查看
      if (this.type == 2) {
        this.seeDis = true; // 文本框置灰
        this.showSeeDis = false; // 按钮隐藏
      }
    },
    // 合作品牌-返回数据
    refreshSelectBrand(dataList) {
      this.tableUsers = dataList
    },
    // 取消
    goback(){
      this.$router.go(-1);
    },
    // 保存提交
    endPreservation(){
      this.price = String(this.price).replace(/^(\s+|\.+|\D+)/,'').replace(/([^0-9\.])$/,'').replace(/(\d+)(\.)(\d+)(\.)/,'$1$2$3').replace(/(\d+)(\.)(\.+|\D+)/,'$1$2').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')
      if(this.cardName == ""){
        this.showAlert('请输入会员卡名称');
        return false;
      }else if(this.price == "" || this.price <= 0 || this.price > 10000000){
        this.showAlert('请输入正确的会员卡价格, ( 价格区间为 ￥ 0.01 - 9999999.99 ) !');
        return false;
      }else if(this.useTimeId == 0){
        this.showAlert('请选择会员卡有效期');
        return false;
      }else if(this.tableUsers == []){
        this.showAlert('请添加会员卡合作品牌');
        return false;
      }
      var obj = {
         UserId: localStorage.Id,
         Id: this.cardId,
         Name: this.cardName, // 会员卡名称。最多10字符
         Price: this.price, // 会员卡售价，取值范围：￥1-9999999
         UseTimeId: this.useTimeId, // 会员卡有效期
         cityIds: this.openCity.map(item=>item[1]).join(",") // 城市ID，已逗号分隔
       }
       getUpdateVIPCard(obj).then(data=>{
          if(data.ResultCode == 1){
            this.showAlert('保存成功', 'success');
            this.$router.go(-1);
          }
       });
    },
    // 请选择省市
    handleChange(val) {
      this.openCity = val
      if(val.length >= 0){
        let addParams = {
          vipCardId: this.cardId, // 会员卡ID
          vipOpenCities: val.map(item=>item[1]).join(","), // 已选择的城市, 以逗号分隔
        };
        getSelectCCPByCity(addParams).then(r => {
          if (r.ResultCode == 1) {
            this.tableUsers = r.ResultObj
          }
          if(r.ResultCode == 4) {
            this.tableUsers = []
          }
        });
      }else{
        this.tableUsers = []
      }
    },
    // 查找省
    getprovince() {
      var loginParams = {
        isOpen: 0,
        dataLevel: 2
      };
      getProvinceAndCityAndZoneByDataType(loginParams).then(data => {
        let that = this;
        let cityList = [];
        data.ResultObj.map(item => {
          let cityData = {value:item.Id,label:item.Name,children:[]}
          cityList.push(cityData)
          item.CityList.map(city => {
            cityData.children.push({value:city.Id, label:city.Name})
          })
        });
        that.options = cityList
      });
    },
    // 新增合作品牌弹框
    addNewBrand() {
      if (this.openCity.length == 0) {
        this.showAlert('请选择开放城市');
        return;
      }
      this.brandVisible = true
      this.$nextTick(() => {
        this.$refs.addBrand.init()
      })
    },
    // 编辑合作品牌弹框
    offer(row) {
      this.brandVisible = true
      this.$nextTick(() => {
        this.$refs.addBrand.init(row,true)
      })
    },
    // 单条删除
    deleteone(row){
      this.$swal({
      type:'warning',
      text: '重要信息，你确定要删除吗？',
      showCancelButton:true,
      cancelButtonText: '取消',
      confirmButtonText: '确定',
      }).then(res=>{
        if(res.value){
          var obj = {
            VIPCardBrandAndBB: JSON.stringify([{"BrandId": row.BrandId,"BbId": row.BbId}]), // 品牌id
            vipCardId: this.cardId // 会员卡ID
          }
          deleteCooperatePartner(obj).then(data=>{
            if(data.ResultCode == 1){
              this.tableUsers = data.ResultObj
            }
            if(data.ResultCode == 4){
              this.tableUsers = data.ResultObj
            }
          })
        }
      })
    },
    // 批量删除
    deleteBrand(){
       if(this.brandIdArr.length == 0){
         this.showAlert('请选择需要删除的品牌');
       }else{
        this.$swal({
        type:'warning',
        text: '重要信息，你确定要删除吗？',
        showCancelButton:true,
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        }).then(res=>{
          if(res.value){
            var obj = {
              VIPCardBrandAndBB: JSON.stringify(this.brandIdArr), // 品牌id
              vipCardId: this.cardId // 会员卡ID
            }
            deleteCooperatePartner(obj).then(data=>{
              if(data.ResultCode == 1){
                // this.$swal({
                //   type: "success",
                //   text:"操作成功"
                // });
                this.tableUsers = data.ResultObj
              } else {
                this.tableUsers = data.ResultObj
              }
            })
          }
        })
       }
    },
    // 复选框
    handleSelectionChange(val) {
        this.brandIdArr = [];
        val.forEach(element => {
        this.brandIdArr.push({"BrandId":element.BrandId, "BbId":element.BbId});
      });
    },
    // 合并单元格处理
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      /*
      row 行
      column 列
      rowIndex 列下标
      columnIndex 行下标
      */
      if (columnIndex in [0, 1]) {
        let theList = this.tableUsers.filter((item) => {
            return item.BrandName === row.BrandName
          })
        let the = theList[0]; // 获取相同品牌的第一行数据
        if (the.BbId === row.BbId) {
          return {
            rowspan: theList.length, // 跨行
            colspan: 1
          }
        } else {
          return {
            rowspan: 0, // 0行
            colspan: 0 // 0列
          }
        }
      }
    },
    // 会员卡有效期，基础数据，tableName=tBDVIPCardUseTime
    getTime(){
      var obj = {
         tableName: "tBDVIPCardUseTime",
        keyWord: "",
        parentId: ""
      }
      getkind(obj).then(data=>{
        if(data.ResultCode == 1){
          this.stautIdarr = data.ResultObj
            this.stautIdarr.unshift({
              Id:0,
              Name:"请选择"
            })
        }
      }) 
    },
  },
  mounted() {
    // 获取省
    this.getprovince()
    this.init()
    // 获取会员卡有效期
    this.getTime();
  }
};
</script>
<style scoped>
.cooperative_brand {
  width: 100%;
  height: 20px;
  line-height: 20px;
}
.info {
  font-size: 18px;
  font-weight: 700;
  float: left;
}
.operation_button {
  float: right;
}
.ban_tab {
  margin-bottom: 20px;
}
.dialogForm {
  width: 100%;
  margin: 0 auto;
  padding-bottom: 10px;
  padding-left: 10%;
}
</style>


// WEBPACK FOOTER //
// MemberDetails.vue?6c5f4c7e